import React, { PropsWithChildren, useEffect, useLayoutEffect, useState } from 'react';
import { useAuth } from '@/store/useAuth';
import { useGetProfile } from '@/hooks/use-get-profile';
import { Spiner } from '@/ui-kit';
import { ErrorMessage } from '../error-message';
import { Outlet } from 'react-router-dom';
import { IntroBanned } from '@/components/intro/intro-banned';
import { callYaMetrika } from '@/utils/call-ya-metrika';

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const { data, isLoading, isError, isFetching, refetch, } = useGetProfile();
    const { setProfile, setProfileWasRemovedError } = useAuth((state) => state);
    const [ removedProfileWasRefetched, setRemovedProfileWasRefetched ] = useState(false);
    const [isBanned, setIsBanned] = useState(false);
    const [metrika, setMetrika] = useState(null);
    
    useLayoutEffect(() => {
        if (data) {
            const isProfileRemoved = data.status === 410
            if (!isProfileRemoved)
                setProfileWasRemovedError(null)
            if (
                isProfileRemoved &&
                !removedProfileWasRefetched
            ) {
                setProfileWasRemovedError(true)
                refetch()
                setRemovedProfileWasRefetched(true)
            } else if (!data.data?.is_banned) {
                if (!!data?.data && data.data?.metrics_key) {
                    setMetrika(data.data.metrics_key);
                }
                setProfile(data?.data);
            } else {
                setIsBanned(true);
            }
        }
    }, [data, setProfile, removedProfileWasRefetched]);

    useEffect(() => {
        if (metrika) {
            callYaMetrika(metrika);
        }
    }, [metrika]);

    if (isBanned) {
        return <IntroBanned />;
    }

    if (isError) {
        return <ErrorMessage message={'Ошибка загрузки профиля'} />;
    }

    return isLoading ? <Spiner /> : <>{children || <Outlet />}</>;
};
